import { IonIcon } from '@ionic/react'
import type { ReactNode } from 'react'

/** Icon + header + body detail item on the hero card (v1). */
export const DetailWithIcon = ({
  icon,
  imgSrc,
  imgAlt,
  header,
  body,
}: {
  /** ionicons icon (mutually exclusive with imgSrc) */
  icon?: string
  /** image asset icon (e.g. /assets/equipment.svg) */
  imgSrc?: string
  imgAlt?: string
  header: ReactNode
  body: ReactNode
}) => (
  <div className='assignment-card__detail-item'>
    {imgSrc ? (
      <img
        src={imgSrc}
        alt={imgAlt}
        className='assignment-card__detail-icon assignment-card__detail-icon--img'
      />
    ) : (
      <IonIcon icon={icon} className='assignment-card__detail-icon' />
    )}
    <div>
      <div className='assignment-card__detail-header'>{header}</div>
      <div className='assignment-card__detail-body'>{body}</div>
    </div>
  </div>
)
